import { lazy, type LazyExoticComponent } from 'react'

const MAX_RETRIES = 3
const RETRY_DELAY = 1500

export function lazyRetry<T extends React.ComponentType<any>>(
  load: () => Promise<{ default: T } | T>,
): LazyExoticComponent<T> {
  return lazy(async () => {
    let lastError: unknown

    for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
      try {
        const module = await load()
        if ('default' in module) {
          return module as { default: T }
        }
        return { default: module as T }
      } catch (error) {
        lastError = error
        if (attempt < MAX_RETRIES) {
          await new Promise(resolve => setTimeout(resolve, RETRY_DELAY))
        }
      }
    }

    throw lastError
  })
}
